import { AvField, AvForm } from "availity-reactstrap-validation"
import UseImageUploader from "components/imageUploader/useImageUploader"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

// import Select from "react-select"
import { createBanner, updateBanner } from "store/actions"

const BannerModal = ({ show, onCloseClick, updateData }) => {
  const dispatch = useDispatch()

  const [webImagePreview, setWebImagePreview] = useState([])
  const [appImagePreview, setAppImagePreview] = useState([])
  const [type, setType] = useState("")
  const [imageWebError, setImageWebError] = useState("")
  const [imageAppError, setImageAppError] = useState("")

  useEffect(() => {
    if (updateData?._id) {
      setWebImagePreview(updateData?.web_images)
      setAppImagePreview(updateData?.app_images)
      setType(updateData?.banner_type || "")
    } else {
      setType("MAIN")
    }
  }, [updateData])

  const handleValidSubmit = (e, v) => {
    if (!webImagePreview.length) {
      setImageWebError("Please upload one Web Image")
      return
    }
    setImageWebError("")
    if (!appImagePreview.length) {
      setImageAppError("Please upload one App Image")
      return
    }
    setImageAppError("")

    const Update = {
      ...(v?.priority !== undefined && v?.priority !== ""
        ? { priority: Number(v.priority) }
        : {}),
      web_images: webImagePreview,
      app_images: appImagePreview,
      banner_type: type,
    }
    if (updateData?._id) {
      dispatch(updateBanner(Update, updateData?._id, onCloseClick))
    } else {
      const Create = {
        ...(v?.priority !== undefined && v?.priority !== ""
          ? { priority: Number(v.priority) }
          : {}),
        web_images: webImagePreview,
        app_images: appImagePreview,

        banner_type: type,
      }

      dispatch(createBanner(Create, onCloseClick))
    }
  }

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="p-4">
        <CardTitle>{updateData?._id ? "Edit Banner" : "Add Banner"}</CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <>
              <Col className="px-2 " md={6}>
                <AvField
                  name="priority"
                  type="number"
                  className="form-control"
                  label="Priority"
                  value={updateData?.priority ?? ""}
                  validate={{
                    pattern: {
                      value: "^[1-9]\\d*$",
                      errorMessage: "Priority must be a positive number",
                    },
                  }}
                />
              </Col>
              <Col md={6}>
                <label>
                  Type <span className="text-danger">*</span>
                </label>
                <div className="d-flex gap-3 align-items-center mt-1">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="typeRadio"
                      id="typeMain"
                      value="MAIN"
                      checked={type === "MAIN"}
                      onChange={e => setType(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="typeMain">
                      Main
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="typeRadio"
                      id="typeSub"
                      value="SUB"
                      checked={type === "SUB"}
                      onChange={e => setType(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="typeSub">
                      Sub
                    </label>
                  </div>
                </div>
              </Col>
            </>
          </Row>
          <Row>
            <Col className="col-12 mt-2">
              <label>
                Web Image <span className="text-danger"> *</span>
              </label>
              <UseImageUploader
                imageSize={4}
                setImagesPreview={setWebImagePreview}
                imagesPreview={webImagePreview}
                uploadUrl={"/focusmotors"}
                // isMultiple
              />
              {imageWebError && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.9rem" }}
                >
                  {imageWebError}
                </div>
              )}
            </Col>
            <Col className="col-12 mt-2">
              <label>
                App Image <span className="text-danger"> *</span>
              </label>
              <UseImageUploader
                imageSize={4}
                setImagesPreview={setAppImagePreview}
                imagesPreview={appImagePreview}
                uploadUrl={"/focusmotors"}
                // isMultiple
              />
              {imageAppError && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.9rem" }}
                >
                  {imageAppError}
                </div>
              )}
            </Col>
          </Row>

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

BannerModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
}

export default BannerModal
